import { useId } from 'react';

export default function IconLogoFlightDeck() {
  const id = useId();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="97"
      height="30"
      viewBox="0 0 97 30"
      fill="none"
    >
      <path
        d="M60.7866 17.0777V12.6055L63.8142 11.5195V25.002H60.8982V23.6163C60.3814 24.5034 59.311 25.2238 57.9073 25.2238C55.2115 25.2238 53.2557 23.1177 53.2557 20.3478C53.2557 17.5778 55.213 15.4717 57.9073 15.4717C59.311 15.4717 60.363 16.1371 60.7866 17.0792V17.0777ZM60.7866 20.3462C60.7866 18.9789 59.8447 17.9816 58.5159 17.9816C57.1871 17.9816 56.2818 18.9972 56.2818 20.3462C56.2818 21.6952 57.2054 22.7108 58.5159 22.7108C59.8263 22.7108 60.7866 21.7136 60.7866 20.3462Z"
        fill="#0D1656"
      />
      <path
        d="M87.2983 25.0005V12.6055L90.3259 11.5195V20.1994L93.2801 15.6935H96.6212L93.4636 20.3294L96.7864 25.002H93.2603L90.3244 20.5879V25.002H87.2968L87.2983 25.0005Z"
        fill="#0D1656"
      />
      <path
        d="M10.1732 15.6653V14.9082C10.1732 12.5436 11.317 11.2695 13.9027 11.2695C14.4012 11.2695 15.0281 11.3429 15.3248 11.4546V13.9293C15.1214 13.8559 14.7345 13.7993 14.4012 13.7993C13.5158 13.7993 13.2008 14.1511 13.2008 14.9816V15.6653H15.1948V18.0849H13.2008V24.9738H10.1732V15.6653Z"
        fill="#0D1656"
      />
      <path
        d="M16.4319 24.9746V12.5781L19.4595 11.4922V24.9746H16.4319Z"
        fill="#0D1656"
      />
      <path
        d="M22.5422 14.6161C21.5819 14.6161 20.8066 13.8774 20.8066 12.8985C20.8066 11.9196 21.5819 11.1992 22.5422 11.1992C23.5025 11.1992 24.2777 11.9563 24.2777 12.8985C24.2777 13.8406 23.5208 14.6161 22.5422 14.6161ZM21.0284 24.9769V15.6684H24.056V24.9769H21.0284Z"
        fill="#0D1656"
      />
      <path
        d="M40.0627 24.977H37.035V12.582L40.0627 11.4961V16.9625C40.4694 16.057 41.5398 15.4483 42.7768 15.4483C45.0108 15.4483 46.1179 16.9808 46.1179 19.1971V24.977H43.0903V19.6957C43.0903 18.7352 42.6285 18.0698 41.6132 18.0698C40.7095 18.0698 40.0627 18.6235 40.0627 19.6773V24.9786V24.977Z"
        fill="#0D1656"
      />
      <path
        d="M47.407 15.6672V13.9648L50.4346 12.8789V15.6672H52.5387V18.1602H50.4346V21.6322C50.4346 22.3526 50.7664 22.6845 51.4866 22.6845C51.8552 22.6845 52.1518 22.6294 52.4469 22.5361V24.9374C52.1334 25.0674 51.2833 25.1959 50.6563 25.1959C48.4223 25.1959 47.407 23.8668 47.407 21.8157V15.6656V15.6672Z"
        fill="#0D1656"
      />
      <path
        d="M32.5853 15.6671V17.0528C32.1602 16.1106 31.0899 15.4453 29.6861 15.4453C26.9903 15.4453 25.1263 17.4398 25.1263 20.0996C25.1263 22.7593 26.9903 24.7538 29.6861 24.7538C30.9966 24.7538 32.1052 24.0518 32.5287 23.2947V24.7721C32.5287 26.0646 31.5501 26.7115 30.3131 26.7115C29.3054 26.7115 28.6158 26.3934 28.2564 25.7602L25.634 26.6932C26.5087 28.2533 28.1815 29.0379 30.3498 29.0379C33.2856 29.0379 35.5548 27.2102 35.5548 24.7905V15.6671H32.5823H32.5853ZM30.2962 22.2791C28.9858 22.2791 28.1188 21.3553 28.1188 20.0996C28.1188 18.8438 28.9858 17.92 30.2962 17.92C31.6067 17.92 32.5303 18.8438 32.5303 20.0996C32.5303 21.3553 31.625 22.2791 30.2962 22.2791Z"
        fill="#0D1656"
      />
      <path
        d="M83.422 21.4169H83.3945C83.1177 22.1006 82.5076 22.7094 81.3455 22.7094C79.9433 22.7094 79.2047 21.6387 79.2047 20.3448C79.2047 19.0508 79.9433 17.9802 81.3455 17.9802C82.4908 17.9802 83.0963 18.5706 83.3792 19.2405L86.1148 18.5216C85.4603 16.8239 83.737 15.4688 81.3654 15.4688C78.2276 15.4688 76.2153 17.5366 76.2153 20.3448C76.2153 23.1529 78.2276 25.2208 81.3654 25.2208C83.6529 25.2208 85.3334 23.959 86.0368 22.3469L83.4235 21.4169H83.422Z"
        fill="#0D1656"
      />
      <path
        d="M68.1524 21.5668C68.1248 21.4705 68.0973 21.3726 68.079 21.2686H75.0196V20.3631C75.0196 17.3531 72.9522 15.4688 70.0729 15.4688C67.1936 15.4688 65.1079 17.4449 65.1079 20.3264C65.1079 21.108 65.2501 21.8253 65.5162 22.4585L68.1524 21.5668ZM70.1096 17.5749C71.2534 17.5749 71.9736 18.2952 72.1219 19.4026H68.079C68.2456 18.2387 68.9643 17.5749 70.1096 17.5749Z"
        fill="#0D1656"
      />
      <path
        d="M72.1662 22.0977H72.1586C71.8084 22.6697 71.1066 23.0215 70.2013 23.0215C69.2961 23.0215 68.7242 22.6651 68.3924 22.1145L65.7853 22.997C66.5942 24.369 68.1019 25.2193 70.2013 25.2193C72.1525 25.2193 73.7626 24.2558 74.57 22.9113L72.1662 22.0977Z"
        fill="#0D1656"
      />
      <path
        d="M8.91485 4.52411V12.7008C8.91485 15.1311 6.94231 17.1026 4.51409 17.1026C2.08434 17.1026 0.113325 15.1296 0.113325 12.7008V5.33015C0.113325 2.94415 2.04917 1.00781 4.43458 1.00781H5.40097C7.3414 1.00781 8.91638 2.58319 8.91638 4.52411H8.91485Z"
        fill={`url(#paint0_linear_${id})`}
      />
      <path
        style={{ mixBlendMode: 'multiply' }}
        d="M8.91489 2.14453H2.96208C1.40086 2.14453 0.134766 3.41095 0.134766 4.97409V12.9626C0.134766 12.9626 0.295322 12.6139 0.38401 12.5267C2.36573 10.5904 7.07079 10.806 8.91642 11.5402V2.14453H8.91489Z"
        fill={`url(#paint1_linear_${id})`}
      />
      <path
        d="M11.6565 0.962467H2.96202C1.40081 0.962467 0.133179 2.22889 0.133179 3.79202V13.1234C0.172935 9.89928 9.27417 9.79222 9.27417 9.79222H11.6565C14.0939 9.79222 16.0695 7.81611 16.0695 5.37658C16.0695 2.93857 14.0939 0.960938 11.6565 0.960938V0.962467Z"
        fill={`url(#paint2_linear_${id})`}
      />
      <path
        d="M8.89648 4.51646V12.7099C8.89648 15.1342 6.92853 17.1026 4.5049 17.1026C2.08126 17.1026 0.113305 15.1342 0.113305 12.7099V5.32098C0.113305 2.94109 2.04456 1.00781 4.42538 1.00781H5.38872C7.32456 1.00781 8.89648 2.58013 8.89648 4.51646Z"
        fill={`url(#paint3_linear_${id})`}
      />
      <path
        style={{ mixBlendMode: 'multiply' }}
        d="M8.89646 2.14453H2.94213C1.37938 2.14453 0.113281 3.41095 0.113281 4.97409V12.9626C0.113281 12.9626 0.273837 12.6139 0.362525 12.5267C2.34425 10.5904 7.05083 10.806 8.89646 11.5402V2.14453Z"
        fill={`url(#paint4_linear_${id})`}
      />
      <path
        d="M11.6381 0.962467H2.94213C1.37938 0.962467 0.113281 2.22889 0.113281 3.79202V13.1234C0.153038 9.89928 9.2558 9.79222 9.2558 9.79222H11.6381C14.0755 9.79222 16.0527 7.81611 16.0527 5.37658C16.0527 2.93857 14.0771 0.960938 11.6397 0.960938L11.6381 0.962467Z"
        fill={`url(#paint5_linear_${id})`}
      />
      <defs>
        <linearGradient
          id={`paint0_linear_${id}`}
          x1="4.39941"
          y1="3.69819"
          x2="4.74516"
          y2="18.5541"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.26" stopColor="#06319F" />
          <stop offset="0.7" stopColor="#305CEF" />
          <stop offset="1" stopColor="#00ABFE" />
        </linearGradient>
        <linearGradient
          id={`paint1_linear_${id}`}
          x1="-0.645078"
          y1="7.80518"
          x2="8.30484"
          y2="6.74118"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#06319F" />
          <stop offset="0.46" stopColor="#063BA4" stopOpacity="0.5" />
          <stop offset="0.82" stopColor="#0643A9" stopOpacity="0.14" />
          <stop offset="1" stopColor="#0647AB" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id={`paint2_linear_${id}`}
          x1="-7.55363"
          y1="7.04372"
          x2="18.8647"
          y2="7.04372"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#07EEFB" />
          <stop offset="0.95" stopColor="#2A54EB" />
        </linearGradient>
        <linearGradient
          id={`paint3_linear_${id}`}
          x1="4.39021"
          y1="3.69819"
          x2="4.73596"
          y2="18.5541"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.26" stopColor="#06319F" />
          <stop offset="0.7" stopColor="#305CEF" />
          <stop offset="1" stopColor="#00ABFE" />
        </linearGradient>
        <linearGradient
          id={`paint4_linear_${id}`}
          x1="-0.665033"
          y1="7.80518"
          x2="8.28641"
          y2="6.73965"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#06319F" />
          <stop offset="0.46" stopColor="#063BA4" stopOpacity="0.5" />
          <stop offset="0.82" stopColor="#0643A9" stopOpacity="0.14" />
          <stop offset="1" stopColor="#0647AB" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id={`paint5_linear_${id}`}
          x1="-7.57506"
          y1="-0.99987"
          x2="18.8479"
          y2="-0.99987"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#07EEFB" />
          <stop offset="0.95" stopColor="#2A54EB" />
        </linearGradient>
      </defs>
    </svg>
  );
}
